import React, { Suspense } from 'react';

import Hidden from '@material-ui/core/Hidden';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Routes } from '../../weborder/Routes';
import { Typography } from '../atoms/Typography';

const ProfileMenu = React.lazy(() => import('./ProfileMenu'));

const useStyles = makeStyles((theme: Theme) => ({
  headerTop: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    minHeight: '36px',
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(1.25),
    },
  },
  headerWithBackLink: {
    flexDirection: 'row',
  },
}));

type Props = {
  children?: React.ReactNode;
  className?: string;
  id?: string;
  params?: Routes['params'];
  popout?: JSX.Element;
  showProfileMenu?: boolean;
  subtitle?: string;
  tabIndex?: number;
  title?: string;
  titleTestId?: string;
};

export function PageHeader(props: Props): JSX.Element {
  const {
    children,
    className,
    id,
    params,
    popout = null,
    showProfileMenu = false,
    subtitle,
    tabIndex,
    title,
    titleTestId,
  } = props;
  const classes = useStyles();
  const headerTopClasses = clsx(
    classes.headerTop,
    children && classes.headerWithBackLink,
    className !== undefined && className,
  );

  return (
    <header className="fd-header">
      <div className={headerTopClasses}>
        {children}
        {showProfileMenu && (
          <Hidden smUp>
            <Suspense fallback={<div />}>
              <ProfileMenu params={params} />
            </Suspense>
          </Hidden>
        )}
      </div>
      {popout && <Hidden smUp>{popout}</Hidden>}
      {title && (
        <Typography
          id={id}
          tabIndex={tabIndex}
          data-fd={titleTestId}
          variant="h1"
        >
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="body2-secondary">{subtitle}</Typography>
      )}
    </header>
  );
}
